import { useAuth } from '../utils/auth';
import dayjs from 'dayjs';
import "dayjs/locale/fr";

export function useApiPackages() {

  const auth = useAuth();
  const resource = auth.apiBaseUrl + '/package';

  const getData = async function (filter, paginationModel, filterModel, sortModel) {

    paginationModel = paginationModel || {page : 0, pageSize : 25};
    let page = paginationModel.page || 0 ;
    let pageSize =  paginationModel.pageSize || 25;
    
    let aFilters = [], aSorters = [];    
    let userFilters = [], userSorters = [] ;

    filterModel = filterModel || {items : []};
    sortModel = sortModel || [];    
    
    if (filterModel.items.length>0) {      
      filterModel.items.forEach(element => {
        userFilters.push({
          property : element.field,
          operator : element.operator,
          value : element.value
        });
      });      
    }

    if (sortModel.length>0) {      
      sortModel.forEach(element => {
        userSorters.push({
          property : element.field,
          direction : element.sort
        });
      });      
    }

    // En cours
    if (filter==='inuse') {
      aFilters = [{property:"upk_status",value:0,operator:"="}, {property:"upk_pass_solde",value:0,operator:">"}];
      aSorters = [{property:"upk_id", direction: 'ASC'}];
    }

    // En attente
    if (filter==='wait') {
      aFilters = [{property:"upk_status",value:-100,operator:"="}];
      aSorters = [{property:"upk_id", direction: 'DESC'}];
    }


    // Historique
    if (filter==='history') {
      aFilters = [{property:"upk_status",value:100,operator:"="}, {connector : "OR", property:"upk_pass_solde",value:0,operator:"<="}];
      aSorters = [{property:"upk_id", direction: 'DESC'}];
    }

    if (userFilters.length>0) {
      aFilters = aFilters.concat(userFilters);
    }

    return fetch(resource  + '?start=' + (page * pageSize) + '&count=' + pageSize + '&filters=' + JSON.stringify(aFilters) + '&sorters=' + JSON.stringify(aSorters), {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : "")                    
      },
      method: "GET"
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Acces non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }
    }).catch(error => {
      return {          
        returnCode : -500,
        returnMsg : (error.response || error.request || error.message)
      }  ;      
    })
  };


  const updateData = async function (data) {
    // on contrôle ce qui peut être modifé
    var dataToPut = {
      upk_is_active : data.upk_is_active,
      upk_data : {
        status : {
          startDateValidity : data.upk_date_start ? dayjs(data.upk_date_start).format('YYYY-MM-DD',) : '', 
          endDateValidity  : data.upk_date_end ? dayjs(data.upk_date_end ).format('YYYY-MM-DD') : ''
        }  
      }
    };
    console.log(data, dataToPut);

    return fetch(resource + '/' + data.upk_id, {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : "")                    
      },
      method: "PUT",
      body  : JSON.stringify(dataToPut)
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Acces non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }     
    }).catch(error => {
      return {          
        returnCode : -500,
        returnMsg : (error.response || error.request || error.message)
      }  ;       
    })
  };


  return {
    getData,
    updateData
  };
}
